import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';
import { addFormsConditions } from 'src/modules/SuperAdmin/store/actions/formconditions.action';
import { CustomIcons } from '../../../../../../icons/Custom.icon';

const AddHumanScribe = ({
  isOpen,
  setIsOpen,
  filterSetSelectedOrganizationUUID,
  filterSetSelectedOrganization,
}) => {
  const initialValues = {
    org_uuid: '',
    condition_id: '',
    form_id: '',
  };
  const { getActiveOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );
  const { possibleStatus } = useSelector((state) => state?.humanScribeState);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [customIconsOptions, setCustomIconsOptions] = useState([]);
  const [selectedOrganizationUUID, setSelectedOrganizationUUID] =
    useState(null);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  // const [selectedHumanScribe, setSelectedHumanScribe] = useState(null);
  const [possibleStatusOptions, setPossibleStatusOptions] = useState([]);

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key) => {
        dataArr.push({
          value: key?.org_uuid,
          label: key?.org_name,
        });
      });
      setOrganizationOptions(dataArr);
    }
  }, [getActiveOrganizationsList]);

  const conditionOptions = [
    {
      value: 'aura_status_mapping',
      label: 'Aura Status',
    },
  ];

  useEffect(() => {
    for (const key in CustomIcons) {
      if (Object.prototype.hasOwnProperty.call(CustomIcons, key)) {
        customIconsOptions.push({
          value: key,
          label: CustomIcons[key], // Icon itself as the label
        });
      }
    }
    setCustomIconsOptions(customIconsOptions);
  }, []);

  useEffect(() => {
    if (
      possibleStatus?.encounter_statuses &&
      Array.isArray(possibleStatus?.encounter_statuses)
    ) {
      let dataArr = [];
      possibleStatus?.encounter_statuses?.forEach((key) => {
        dataArr.push({
          value: key?.status_name,
          label: key?.status_name,
        });
      });
      setPossibleStatusOptions(dataArr);
    }
  }, []);

  const validationSchemaField = Yup.object().shape({
    org_uuid: Yup.string().required(' '),
    condition_id: Yup.string().required(' '),
    form_id: Yup.string().required(' '),
  });

  const dispatch = useDispatch();

  const sections = [
    {
      heading: 'Add form condition',
      fields: [],
    },
    {
      className: 'grid grid-cols-4 gap-4',
      fields: [
        {
          name: 'org_uuid',
          type: 'select',
          title: 'Organization name',
          placeholder: 'Select organization',
          options: organizationOptions,
          onChange: (setFieldValue, e, option) => {
            setFieldValue('org_uuid', e);
            setSelectedOrganizationUUID(e);
            setSelectedOrganization(option?.label);
          },
        },
        {
          name: 'condition_id',
          type: 'select',
          title: 'Condition name',
          placeholder: 'Select condition',
          options: conditionOptions,
          disabled: selectedOrganizationUUID ? false : true,
          onChange: (setFieldValue, e) => {
            console.log(e);
            setFieldValue('condition_id', e);
            // setSelectedHumanScribe(e);
          },
        },
        {
          name: 'status_id',
          type: 'select',
          title: 'Status name',
          placeholder: 'Enter status',
          disabled: selectedOrganizationUUID ? false : true,
          options: possibleStatusOptions,
          onChange: (setFieldValue, e) => {
            console.log(e);
            setFieldValue('status_id', e);
            //   setSelectedHumanScribe(e);
          },
        },
        {
          name: 'icon_id',
          type: 'select',
          title: 'Icon',
          placeholder: 'Select icon',
          options: customIconsOptions,
          disabled: selectedOrganizationUUID ? false : true,
          onChange: (setFieldValue, e) => {
            console.log(e);
            setFieldValue('icon_id', e);
          },
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      className={'feedback-modal'}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={(values) => {
        const payload = {
          condition_id: values?.condition_id,
          form_id: values?.form_id,
          org_uuid: values?.org_uuid,
        };
        //Filter here refers to what is selected in the home page
        dispatch(
          addFormsConditions(
            payload,
            setIsOpen,
            filterSetSelectedOrganization,
            filterSetSelectedOrganizationUUID,
            selectedOrganization
          )
        );
      }}
    />
  );
};

export default AddHumanScribe;
